import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Footer from './Footer';
import SocialSidebar from '../components/SocialSideBar';
import DoubtDetailDrawer from '../components/doubt/DoubtDetailDrawer';
import StudentDoubtView from '../components/doubt/StudentDoubtView';
import AdminDoubtDashboard from '../components/doubt/AdminDoubtDashboard';
import styles from './doubtPortal.module.css';
import doubtBgDesktop from './image/doubt.png';
import doubtBgMobile from './image/prrepx_doubt0.png';

export default function DoubtPortalPage() {
  const { currentUser, userData } = useAuth();
  const isAdmin = userData?.isAdmin === true || userData?.isSuperAdmin === true;
  const isStudent = !!currentUser && !isAdmin;

  const [selectedDoubt, setSelectedDoubt] = useState(null);

  // ── Shared detail drawer ──────────────────────────────────────────
  const drawer = selectedDoubt && (
    <DoubtDetailDrawer doubt={selectedDoubt} onClose={() => setSelectedDoubt(null)} />
  );

  // ── Admin view ────────────────────────────────────────────────────
  if (isAdmin) {
    return (
      <div className={styles.page}>
        <SocialSidebar />
        <div className={styles.adminHeader}>
          <div className={styles.adminHeaderInner}>
            <span className={styles.adminBadge}>🛡️ Admin Dashboard</span>
            <h1 className={styles.adminTitle}>Doubt Portal — <span className={styles.adminAccent}>Management Console</span></h1>
            <p className={styles.adminSub}>Review, organise and answer every student doubt across all classes &amp; subjects.</p>
          </div>
        </div>
        <AdminDoubtDashboard onOpenDoubt={setSelectedDoubt} />
        {drawer}
        <Footer />
      </div>
    );
  }

  // ── Student / guest view ──────────────────────────────────────────
  return (
    <div className={styles.page}>
      <SocialSidebar />

      {/* Hero */}
      <section className={styles.hero}>
        <img src={doubtBgDesktop} alt="" className={styles.heroBgDesktop} />
        <div className={styles.heroGlow1} /><div className={styles.heroGlow2} /><div className={styles.heroGlow3} />

        <div className={styles.heroMobileImg}>
          <img src={doubtBgMobile} alt="Doubt Portal" className={styles.heroMobileSlide} />
        </div>

        <div className={styles.heroContent}>
          <span className={styles.heroBadge}>📚 Ask Academic Doubts 24×7</span>
          <h1 className={styles.heroTitle}>
            Doubt Portal <span className={styles.heroAccent}>24×7</span>
          </h1>
          <p className={styles.heroSub}>
            <span className={styles.heroHighlight}>Get all your doubts solved by 100% IIT / NIT &amp; top medical alumni.</span><br />
            One stop solution for all your doubts. Free and accessible to everyone.
          </p>
          <div className={styles.heroStats}>
            <span>✅ All Subjects</span>
            <span className={styles.statDivider} />
            <span>🎯 JEE / NEET + Class 11–12</span>
            <span className={styles.statDivider} />
            <span>⚡ 100% Free</span>
          </div>
          {!currentUser && (
            <div className={styles.heroActions}>
              <a href="/login" className={styles.heroAskBtn}>Login to Ask a Doubt →</a>
            </div>
          )}
        </div>
      </section>

      {/* Student inline form + history */}
      {isStudent ? (
        <StudentDoubtView onOpenDoubt={setSelectedDoubt} />
      ) : (
        /* Guest: show login nudge card */
        <div className={styles.guestNudge}>
          <span className={styles.guestEmoji}>🔒</span>
          <h2 className={styles.guestTitle}>Login to Ask &amp; Track Your Doubts</h2>
          <p className={styles.guestHint}>Create a free account to submit doubts and track answers from PrepX Team.</p>
          <a href="/login" className={styles.guestBtn}>Login / Sign Up — It's Free</a>
        </div>
      )}

      {drawer}
      <Footer />
    </div>
  );
}
